import * as React from "react";
import edocLogo from "../assets/images/edoc.png";

const EdocLogo: React.FC = (): JSX.Element => {
  return <img src={edocLogo} className="edoc-logo" alt="edoc-logo" />;
};

export default EdocLogo;
